export default __webpack_public_path__ + "static/media/12.f16e9898.jpg";